import {
  PriceListAddPath,
  PriceListEditPath,
  PriceListListPath,
  PriceListPath,
  PriceListPriceAddPath,
  PriceListPriceEditPath,
  PriceListPriceListPath,
  ProductAddPath,
  ProductCategoryAddPath,
  ProductCategoryEditPath,
  ProductCategoryListPath,
  ProductCategoryProductListPath,
  ProductEditPath,
  ProductListAddPath,
  ProductListEditPath,
  ProductListListPath,
  ProductListPath,
  ProductListPreviewPath,
  ProductListProductListPath,
  ProductListRetailerListPath,
  ProductListStoreListPath,
  PromotionAddPath,
  PromotionEditPath,
  PromotionListPath,
} from '@/modules/product/paths';
import { HomePath } from '@/routing/paths';

const home = { label: 'Home', path: HomePath };

const productList = { label: 'Products', path: ProductListPath };
const productAdd = { label: 'Add', path: ProductAddPath };
const productEdit = { label: 'Edit', path: ProductEditPath.path };
const productCategoryList = { label: 'Product Categories', path: ProductCategoryListPath };
const productCategoryAdd = { label: 'Add', path: ProductCategoryAddPath };
const productCategoryEdit = { label: 'Edit', path: ProductCategoryEditPath.path };
const productCategoryProductList = { label: 'Products', path: ProductCategoryProductListPath.path };
const productListList = { label: 'Product Lists', path: ProductListListPath };
const productListAdd = { label: 'Add', path: ProductListAddPath };
const productListOverview = { label: 'Overview', path: ProductListEditPath.path };
const productListProductList = {
  label: 'Products in List',
  path: ProductListProductListPath.path,
};
const productListRetailerList = {
  label: 'Retailer Assignments',
  path: ProductListRetailerListPath.path,
};
const productListStoreList = { label: 'Store Assignments', path: ProductListStoreListPath.path };
const productListPreview = { label: 'Preview', path: ProductListPreviewPath.path };
const priceListList = { label: 'Pricing', path: PriceListListPath };
const priceListAdd = { label: 'Add', path: PriceListAddPath };
const priceListEdit = { label: 'Edit', path: PriceListEditPath.path };
const priceListPriceList = { label: 'Prices', path: PriceListPriceListPath.path };
const priceListPriceAdd = { label: 'Add', path: PriceListPriceAddPath.path };
const priceListPriceEdit = { label: 'Edit', path: PriceListPriceEditPath.path };
const promotionList = { label: 'Promotions', path: PromotionListPath };
const promotionAdd = { label: 'Add', path: PromotionAddPath };
const promotionEdit = { label: 'Edit', path: PromotionEditPath.path };

const breadcrumbs = [
  {
    path: ProductListPath,
    items: [home, productList],
  },
  {
    path: ProductAddPath,
    items: [home, productList, productAdd],
  },
  {
    path: ProductEditPath.path,
    items: [home, productList, productEdit],
  },
  {
    path: ProductCategoryListPath,
    items: [home, productCategoryList],
  },
  {
    path: ProductCategoryAddPath,
    items: [home, productCategoryList, productCategoryAdd],
  },
  {
    path: ProductCategoryEditPath.path,
    items: [home, productCategoryList, productCategoryEdit],
  },
  {
    path: ProductCategoryProductListPath.path,
    items: [home, productCategoryList, productCategoryEdit, productCategoryProductList],
  },
  {
    path: ProductListListPath,
    items: [home, productListList],
  },
  {
    path: ProductListAddPath,
    items: [home, productListList, productListAdd],
  },
  {
    path: ProductListEditPath.path,
    items: [home, productListList, productListOverview],
  },
  {
    path: ProductListProductListPath.path,
    items: [home, productListList, productListProductList],
  },
  {
    path: ProductListRetailerListPath.path,
    items: [home, productListList, productListRetailerList],
  },
  {
    path: ProductListStoreListPath.path,
    items: [home, productListList, productListStoreList],
  },
  {
    path: ProductListPreviewPath.path,
    items: [home, productListList, productListPreview],
  },
  {
    path: PriceListPath,
    items: [home, priceListList],
  },
  {
    path: PriceListListPath,
    items: [home, priceListList],
  },
  {
    path: PriceListAddPath,
    items: [home, priceListList, priceListAdd],
  },
  {
    path: PriceListEditPath.path,
    items: [home, priceListList, priceListEdit],
  },
  {
    path: PriceListPriceListPath.path,
    items: [home, priceListList, priceListEdit, priceListPriceList],
  },
  {
    path: PriceListPriceAddPath.path,
    items: [home, priceListList, priceListEdit, priceListPriceList, priceListPriceAdd],
  },
  {
    path: PriceListPriceEditPath.path,
    items: [home, priceListList, priceListEdit, priceListPriceList, priceListPriceEdit],
  },
  {
    path: PromotionListPath,
    items: [home, promotionList],
  },
  {
    path: PromotionAddPath,
    items: [home, promotionList, promotionAdd],
  },
  {
    path: PromotionEditPath.path,
    items: [home, promotionList, promotionEdit],
  },
];

export default breadcrumbs;
